import getUrlParams from './get-url-params';

const isSEM = () => {
  const urlParams = new window.URLSearchParams(getUrlParams());
  return urlParams?.get('utm_source') === 'google' && urlParams?.get('utm_medium') === 'cpc';
};

export default isSEM;
